import { ScoopText } from '../../../../ui'
import styles from './StatStrip.module.scss'

/**
 * StatStrip — the at-a-glance stat row for report answer zones
 * (target-state design, review D1). Each stat is { value, label, tone }.
 * Tone colors a value ONLY to signal "this needs attention":
 *   'critical' | 'error' | 'warning' — used for Critical/Severe/Moderate and
 *   Flagged when > 0. 'critical' is the loudest and belongs to that tier alone.
 * Everything else stays neutral so color keeps its meaning.
 */
export const StatStrip = ({ items = [], className }) => {
    if (!items.length) return null
    return (
        <div className={`${styles.strip} ${className || ''}`}>
            {items.map((item, index) => (
                <div key={`${item.label}-${index}`} className={styles.stat}>
                    <ScoopText
                        className={`${styles.value} ${
                            item.tone === 'critical'
                                ? styles.valueCritical
                                : item.tone === 'error'
                                  ? styles.valueError
                                  : item.tone === 'warning'
                                    ? styles.valueWarning
                                    : ''
                        }`}
                    >
                        {item.value}
                    </ScoopText>
                    <ScoopText className={styles.label}>{item.label}</ScoopText>
                </div>
            ))}
        </div>
    )
}
